(exports.OP_ID = "6916e6985916a55e4bcaf513"),
  (exports.FORM_ID = "692e96eec20f614d5eea04aa"),
  (exports.SERVER_URL = "https://api.hva-pro.fr"),
  (exports.UPDATE = "6878fc947e06ac29cf5672e2"),
  (exports.ITEMS = "692e96eec20f614d5eea04aa"),
  (exports.BD_NAME = "jeu-dev");
